import { isFinite, isNil } from 'lodash'

const TIPOS_ONLY = {
  roles: function ({ items, store }) {
    return !!(!items?.length || items.includes(store.getters['auth/role']))
  },
  status: function ({ items, route }) {
    return !!(!items?.length || 
        !Object.hasOwn(route?.meta ?? {}, 'status') || 
        items.includes(isFinite(route.meta.status) && !isNil(route.meta.status) ? route.meta.status : 99999)
    )
  },
  empty: function ({ items, data }) {
    const requireEmpty = !!items
    data = Array.isArray(data) ? data : Object.keys(data || {})
    return !!data.length !== requireEmpty
  }
}
    
export {
  TIPOS_ONLY
}
